// オーバーレイ 共通関数 -----
const addOverlay = (overlay, owner) => {
	overlay.classList.add("is-active");
	overlay.dataset.overlayOwner = owner;
	overlay.classList.toggle("is-header", owner === "header");
	overlay.classList.toggle("is-other", owner !== "header");
	document.body.classList.add("is-fixed");
};

const removeOverlay = (overlay, owner) => {
	if (overlay.dataset.overlayOwner !== owner) return;

	overlay.classList.remove("is-active", "is-header", "is-other");
	delete overlay.dataset.overlayOwner;
	document.body.classList.remove("is-fixed");
};

// ハンバーガーメニュー -----
document.addEventListener("DOMContentLoaded", () => {
	const mq = window.matchMedia("(max-width: 768px)");
	const ham = document.querySelector(".header__ham");
	const content = document.querySelector(".header__content");
	const overlay = document.querySelector(".c-overlay");
	const lead = document.querySelector(".header__lead.u-show--tab-sp");
	const overlayOwner = "header";

	if (!ham || !content || !overlay) return;

	const openMenu = () => {
		ham.classList.add("is-active");
		content.classList.add("is-active");
		lead?.classList.add("is-menu-open");

		addOverlay(overlay, overlayOwner);

		ham.setAttribute("aria-expanded", "true");
	};

	const closeMenu = () => {
		ham.classList.remove("is-active");
		content.classList.remove("is-active");
		lead?.classList.remove("is-menu-open");
		ham.setAttribute("aria-expanded", "false");

		removeOverlay(overlay, overlayOwner);
	};

	const toggleMenu = () => {
		if (!mq.matches) return;

		content.classList.contains("is-active") ? closeMenu() : openMenu();
	};

	ham.addEventListener("click", toggleMenu);
	overlay.addEventListener("click", closeMenu);

	content.addEventListener("click", (e) => {
		if (e.target.closest("a")) closeMenu();
	});

	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") closeMenu();
	});

	mq.addEventListener("change", (e) => {
		if (!e.matches) closeMenu();
	});
});

// トップに戻る -----
document.addEventListener("DOMContentLoaded", () => {
	const pageTop = document.querySelector(".c-page-top");

	if (!pageTop) return;

	const checkPageBottom = () => {
		const scrollBottom = window.scrollY + window.innerHeight;
		const documentHeight = document.documentElement.scrollHeight;
		const isBottom = scrollBottom >= documentHeight - 1;

		pageTop.classList.toggle("is-bottom", isBottom);
	};

	pageTop.addEventListener("click", (e) => {
		e.preventDefault();

		window.dispatchEvent(new CustomEvent("pageTopScrollStart"));

		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	});

	window.addEventListener("scroll", checkPageBottom, { passive: true });
	window.addEventListener("resize", checkPageBottom);

	checkPageBottom();
});

// .c-jobs-cards -----
const jobsCardsMq = window.matchMedia("(max-width: 768px)");
const $jobsCardsSlider = jQuery(".c-jobs-cards");

if ($jobsCardsSlider.length) {
	// .c-jobs-cards__head 高さ ---
	const setJobsCardsHeadHeight = () => {
		const heads = [...document.querySelectorAll(".c-jobs-cards__head")];

		if (!heads.length) return;

		heads.forEach((head) => {
			head.style.paddingTop = "";
			head.style.minHeight = "";
		});

		const getTypeSpace = (head) => {
			const type = head.querySelector(".c-jobs-cards__type");

			if (!type) return 0;

			const style = window.getComputedStyle(type);
			const marginBottom = parseFloat(style.marginBottom) || 0;

			return type.offsetHeight + marginBottom;
		};

		const addTypeSpace = (head, space) => {
			if (head.querySelector(".c-jobs-cards__type")) return;
			if (!space) return;

			head.style.paddingTop = `${space}px`;
		};

		// SP
		if (jobsCardsMq.matches) {
			const hasType = heads.some((head) => head.querySelector(".c-jobs-cards__type"));

			if (hasType) {
				const typeSpace = Math.max(...heads.map(getTypeSpace));

				heads.forEach((head) => {
					addTypeSpace(head, typeSpace);
				});
			}

			const maxHeight = Math.max(...heads.map((head) => head.offsetHeight));

			heads.forEach((head) => {
				head.style.minHeight = `${maxHeight}px`;
			});

			return;
		}

		// PC
		for (let i = 0; i < heads.length; i += 2) {
			const left = heads[i];
			const right = heads[i + 1];

			if (!right) break;

			const typeSpace = Math.max(getTypeSpace(left), getTypeSpace(right));

			addTypeSpace(left, typeSpace);
			addTypeSpace(right, typeSpace);

			const maxHeight = Math.max(left.offsetHeight, right.offsetHeight);

			left.style.minHeight = `${maxHeight}px`;
			right.style.minHeight = `${maxHeight}px`;
		}
	};

	// .c-jobs-cards SPスライダー ---
	const initJobsCardsSlider = () => {
		if (!$jobsCardsSlider.hasClass("slick-initialized")) {
			$jobsCardsSlider.slick({
				autoplay: true,
				autoplaySpeed: 5000,
				arrows: false,
				centerMode: true,
				centerPadding: "0",
				dots: true,
				dotsClass: "slick-dots c-jobs-cards__dots",
				pauseOnFocus: false,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				slidesToShow: 1,
				variableWidth: true,
			});
		}
	};

	const destroyJobsCardsSlider = () => {
		if ($jobsCardsSlider.hasClass("slick-initialized")) {
			$jobsCardsSlider.slick("unslick");
		}
	};

	const checkJobsCardsSlider = () => {
		if (jobsCardsMq.matches) {
			initJobsCardsSlider();

			if ($jobsCardsSlider.hasClass("slick-initialized")) {
				$jobsCardsSlider.slick("setPosition");
			}

			requestAnimationFrame(() => {
				setJobsCardsHeadHeight();
			});
		} else {
			destroyJobsCardsSlider();
			setJobsCardsHeadHeight();
		}
	};

	checkJobsCardsSlider();

	jobsCardsMq.addEventListener("change", checkJobsCardsSlider);

	let jobsCardsResizeTimer;

	jQuery(window).on("resize", () => {
		clearTimeout(jobsCardsResizeTimer);

		jobsCardsResizeTimer = setTimeout(() => {
			checkJobsCardsSlider();
		}, 200);
	});

	window.addEventListener("load", () => {
		checkJobsCardsSlider();
	});
}
